/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")
@file:OptIn(ExperimentalJsExport::class)
package features.userNotificationPreferences

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.Result.Idle
import kangaroorewards.appsdk.core.domain.Result.Loading
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kangaroorewards.appsdk.core.utils.CFlow
import kangaroorewards.appsdk.core.utils.asCFlow
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.mapLatest
import kotlinx.serialization.InternalSerializationApi
import kotlin.js.ExperimentalJsExport
import features.userNotificationPreferences.internal.GetNotificationPreferencesUseCase
import features.userNotificationPreferences.internal.GetNotificationPreferencesUseCase.Params
import features.userNotificationPreferences.models.NotificationSettingsModel


typealias GetNotificationPreferencesState = CFlow<GetNotificationPreferencesUseCaseResult?>

typealias GetNotificationPreferencesUseCaseResult = Result<NotificationSettingsModel>

fun GetNotificationPreferencesUseCaseResult.serializeGetNotificationPreferencesApiResult(): SerializedResult<String> {
    return this.toJsonResult<NotificationSettingsModel>()
}

/**
 * Serializes [GetNotificationPreferencesState]'s data and returns a new
 * [CFlow] containing data serialized as a JSON [String].
 */
@OptIn(ExperimentalCoroutinesApi::class)
fun GetNotificationPreferencesState.serializeGetNotificationPreferencesState(): CFlow<SerializedResult<String>?> {
    return this.mapLatest {
        it?.toJsonResult<NotificationSettingsModel>()
    }.asCFlow()
}

/**
 * Get a users notification settings.  [Api] class
 */
class GetNotificationPreferencesApi : Api() {

    val getNotificationPreferencesState: GetNotificationPreferencesState
        get() = _getNotificationPreferencesState.asCFlow()

    companion object {
        private val _getNotificationPreferencesState: MutableStateFlow<GetNotificationPreferencesUseCaseResult> = MutableStateFlow(Idle())
    }

    private val getNotificationPreferencesUseCase = GetNotificationPreferencesUseCase()

    /**
     * Get a users notification settings. 
     */
    suspend fun getNotificationPreferences(
        overrideHeaders: Map<String, String>? = null,

    ): Result<NotificationSettingsModel> {
        /* set state to Loading as soon as function is called */
        _getNotificationPreferencesState.value = Loading()
        val result = this.getNotificationPreferencesUseCase(
            Params(
                overrideHeaders = overrideHeaders,

            )
        
        ) { result ->
            _getNotificationPreferencesState.value = result
            return@getNotificationPreferencesUseCase result
        }
        return result
    }

}
